module.exports = __webpack_public_path__ + "img/ICONS_MV.182044fa.png";